import { AAGUID } from '@interticket/core';
import { ICartSeller } from '@core/interfaces/cart/cart-seller.interface';

export class CartSeller implements ICartSeller {

  readonly sellerId: AAGUID;
  readonly partnerId: AAGUID;

  constructor(iCartSeller: ICartSeller) {
    this.sellerId = iCartSeller.sellerId;
    this.partnerId = iCartSeller.partnerId;
  }

}
